import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Header from '@/components/Header';
import HeroVideoSlider from '@/components/HeroVideoSlider';
import LogoScroller from '@/components/LogoScroller';
import AboutSection from '@/components/AboutSection';
import SpeakersSection from '@/components/SpeakersSection';
import WhoAttendsSection from '@/components/WhoAttendsSection';
import KeyThemesSection from '@/components/KeyThemesSection';
import TicketsSection from '@/components/TicketsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/PageHeader';

const Index = () => {
  const { isAuthenticated } = useAuth();
  
  return (
    <div className="min-h-screen bg-ai-dark">
      <Header />
      <HeroVideoSlider />
      <LogoScroller />
      <SpeakersSection hideNickSmirnov />
      <WhoAttendsSection />
      <LogoScroller />
      <TicketsSection />
      <KeyThemesSection />
      
      {/* Venue CTA Banner */}
      <div className="bg-purple-900/70 backdrop-blur-md py-5">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-bold text-white">Venue</h3>
            <p className="text-gray-200">
              The Great Hall
              <br />
              Kensington Conference and Events Centre
              <br />
              Hornton St, Kensington
              <br />
              London W8 7NX
            </p>
          </div>
          <Link to="/venue">
            <Button className="bg-white text-purple-900 hover:bg-gray-100">
              View Venue Details
            </Button>
          </Link>
        </div>
      </div>
      
      <AboutSection />
      <FAQSection />
      
      {/* Register Now! Section */}
      <div className="bg-black/70 backdrop-blur-md py-10 text-center">
        <Link to="/register">
          <Button 
            className="bg-gradient-to-r from-[#F97316] to-[#ea384c] hover:opacity-90 text-white text-xl px-10 py-6 font-semibold shadow-lg"
          >
            Register Now!
          </Button>
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default Index;
